//import arcade from './images/saam-arcade-stars.jpg';
//import htf from './images/htf-homepage.jpg';
//import nasmSite from './images/air-space-site.png';
//import skynet from './images/skynet-pie-chart.png';
//import seliger from './images/seliger.png';

import arcade from './images/arcade-thumbnail.jpg';
import htf from './images/htf-thumbnail.jpg';
import nasmSite from './images/nasm-thumbnail.jpg';
import skynet from './images/pie-thumbnail.jpg';
import seliger from './images/lecture-thumbnail.jpg';

export const leftDoubleCardContent = [
	{
		eyebrow:'Event',
		title: 'SAAM Arcade',
		text: 'Created a two day arcade featuring games, musical performances and programming workshops that was attended by over 20,000 guests.',
		link: '/product-owner-project-management',
		button:'Learn about the Arcade',
		image: arcade,
		altText: 'Insert alt text.',
	},
	{
		eyebrow:'Website',
		title: 'How Things Fly',
		text: 'Managed the migration of a Drupal 5 to a Drupal 8 site and the conversion of 12 Flash interactives and 2 Unity interactives to ReactJS.',
		link: '/product-owner-project-management',
		button:'Learn about the website',
		image: htf,
		altText: 'Insert alt text.',
	},	
]

export const leftFullWidthCardContent = [
	{
		eyebrow:'Website',
		title: 'Air and Space Website',
		text: 'Managing the Smithsonian National Air and Space Museum’s websites, coordinating development work, performing quality assurance testing, designing new features and functionality, and shepherding the sites through their life cycle, upgrades, and maintenance.',
		link: '/product-owner-project-management',
		button:'Learn about the website',
		image: nasmSite,
		altText: 'Insert alt text.',
	},
]

export const rightCardClusterContent = [
	{
		eyebrow:'Website',
		title: 'Skynet Intranet',
		text: 'Manage the Smithsonian National Air and Space Museum’s intranet, using user testing, and analytics to develop a roadmap to a site redesign.',
		link: '/product-owner-project-management',
		button:'Learn about the website',
		image: skynet,
		altText: 'Insert alt text.',
	},
	{
		eyebrow:'Event',
		title: 'Photo DC Lectures',
		text: 'Partnered with Photo DC to create an annual lecture series at the Smithsonian American Art Museum featuring well-known photographers discussing their work.',
		link: '/product-owner-project-management',
		button:'Learn about the lecture',
		image: seliger,
		altText: 'Insert alt text.',
	},
]